import { render } from "./KebabMenu.vue?vue&type=template&id=0b33776c&scoped=true"
import script from "./KebabMenu.vue?vue&type=script&lang=js"
export * from "./KebabMenu.vue?vue&type=script&lang=js"

import "./KebabMenu.vue?vue&type=style&index=0&id=0b33776c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b33776c"]])

export default __exports__